/* eslint-disable jsx-a11y/anchor-is-valid, react/no-unused-prop-types */
import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { StateStore } from '@bingads-webui/state-store';
import { withStateStore } from '@bingads-webui/with-state-store';
import { notificationStore } from '@bingads-webui-react/notification-center';
import {
  CHANNEL_ALL_RECOMMENDATIONS,
  CHANNEL_TYPES,
  isReadOnly,
  RECOMMENDATION_CATEGORIES_IDS,
  RECOMMENDATION_CATEGORIES,
  NOT_SUPPORT_DOWNLOAD_TYPES,
  ADINSIGHT_LOG_API_NAME,
  ADINSIGHT_LOG_ACTION_TYPE,
  RECOMMENDATION_IDS,
  VIEW_TYPES,
  FAC_RECOMMENDATION_CONFIG,
  FAC_RECOMENDATIONTYPE_FEATUREID_MAPPING,
  sharedComponentFunctionStateStore,
  getRecommendationCache,
  setRecommendationCache,
  RECOMMENDATION_TYPES,
} from '@bingads-webui-campaign/recommendation-core';
import { DownloadToolbarButton } from '@bingads-webui-campaign-react/recommendation-visuals';
import { RecommendationModal, AsyncApplyForm, ConfirmForm } from '@bingads-webui-campaign-react/recommendation-modal';

import * as adDisplayUrlService from '@bingads-webui-campaign-legacy/crud-ad/service/displayUrl';
import { combineText } from '@bingads-webui-campaign-legacy/crud-ad/viewmodel/adsPreview/expandedTextAd';
import { TeachingBubble, getTeachingBubbleUserGovernanceConfig } from '@bingads-webui-campaign-react/popup-components';
import { findSiteMap } from '@bingads-webui-campaign-react/with-site-map';

import { OptimizationScoreTeachingBubbleWithUserGovernance } from './optimization-score-teacching-bubble';
import { RecommendationsAutoApplySettings } from './recommendations-auto-apply-settings';

export class recommendationTab extends React.Component {
  static propTypes = {
    campaignAdGroups: PropTypes.arrayOf(PropTypes.object),
    campaignType: PropTypes.number,
    categoryType: PropTypes.string,
    channel: PropTypes.string.isRequired,
    currentActivity: PropTypes.shape({
      trace: PropTypes.func.isRequired,
      error: PropTypes.func.isRequired,
    }).isRequired,
    data: PropTypes.shape(_.reduce(
      CHANNEL_ALL_RECOMMENDATIONS[CHANNEL_TYPES.RECOMMENDATION],
      recommendation => ({
        [recommendation]: PropTypes.object,
      }),
      {}
    )),
    dismissedData: PropTypes.shape(_.reduce(
      CHANNEL_ALL_RECOMMENDATIONS[CHANNEL_TYPES.RECOMMENDATION],
      recommendation => ({
        [recommendation]: PropTypes.object,
      }),
      {}
    )),
    dataService: PropTypes.shape({
      getSummary: PropTypes.func.isRequired,
      getCount: PropTypes.func.isRequired,
      track: PropTypes.func.isRequired,
    }).isRequired,
    el: PropTypes.string.isRequired,
    scope: PropTypes.shape({
      customerId: PropTypes.number.isRequired,
      accountId: PropTypes.number.isRequired,
      levelAt: PropTypes.string.isRequired,
      campaignId: PropTypes.number,
      adGroupId: PropTypes.number,
    }).isRequired,
    hasFilter: PropTypes.bool,
    recommendationType: PropTypes.string,
    reload: PropTypes.func,
    showAlertHandler: PropTypes.func.isRequired,
    source: PropTypes.string,
    setData: PropTypes.func.isRequired,
    hasLoadToken: PropTypes.func.isRequired,
    viewCategory: PropTypes.func.isRequired,
    backToRecommendation: PropTypes.func,
    lastRecommendationType: PropTypes.string,
    lastCampaignId: PropTypes.string,
    lastAdGroupId: PropTypes.string,
    viewDetails: PropTypes.func.isRequired,
    viewBAADetails: PropTypes.func,
    viewSummary: PropTypes.func.isRequired,
    viewHistory: PropTypes.func,
    viewType: PropTypes.string.isRequired,
    deps: PropTypes.shape({
      appConfig: PropTypes.objectOf(PropTypes.any).isRequired,
      appState: PropTypes.object.isRequired,
      i18n: PropTypes.object.isRequired,
      s$i18n: PropTypes.object,
      instrumentation: PropTypes.object.isRequired,
      jsdata: PropTypes.object.isRequired,
      legacyRouter: PropTypes.object.isRequired,
      pageContext: PropTypes.object.isRequired,
      permissions: PropTypes.object.isRequired,
      preferencesService: PropTypes.objectOf(PropTypes.any).isRequired,
      constants: PropTypes.shape({
        imagePath: PropTypes.string.isRequired,
      }).isRequired,
      combineText: PropTypes.func,
      adDisplayUrlService: PropTypes.object,
      odata: PropTypes.PropTypes.shape({
        get: PropTypes.func.isRequired,
        patch: PropTypes.func.isRequired,
      }).isRequired,
      schemaCampaignVnext: PropTypes.object,
      validator: PropTypes.object,
      cacheManager: PropTypes.object,
    }).isRequired,
    vnextDeps: PropTypes.shape({
      customMapperStore: PropTypes.PropTypes.shape({
        setState: PropTypes.func,
      }),
      recommendationDataStore: PropTypes.PropTypes.shape({
        setState: PropTypes.func,
      }),
      newI18n: PropTypes.object,
    }),
    guid: PropTypes.string, // for adinsight view event log in aria
    // eslint-disable-next-line react/forbid-prop-types, react/require-default-props
    perfMarker: PropTypes.object,
    isMCC: PropTypes.bool,
    // eslint-disable-next-line react/forbid-prop-types
    overallOptimizationScoreBar: PropTypes.object,
    categoryScoreUpLifts: PropTypes.arrayOf(PropTypes.object),
    serverContext: PropTypes.shape({}).isRequired,
    classes: PropTypes.objectOf(PropTypes.string),
    store: PropTypes.instanceOf(StateStore),
    availableCategories: PropTypes.arrayOf(PropTypes.string),
    rawCouponData: PropTypes.arrayOf(PropTypes.object),
  };

  static defaultProps = {
    campaignType: null,
    categoryType: null,
    recommendationType: null,
    source: null,
    isMCC: false,
    vnextDeps: {},
    guid: null,
    viewHistory: _.noop,
    viewBAADetails: _.noop,
    backToRecommendation: _.noop,
    lastRecommendationType: undefined,
    reload: _.noop,
    campaignAdGroups: [],
    hasFilter: false,
    data: {},
    dismissedData: {},
    lastCampaignId: undefined,
    lastAdGroupId: undefined,
    overallOptimizationScoreBar: {},
    categoryScoreUpLifts: [],
    classes: {},
    store: null,
    availableCategories: [],
    rawCouponData: null,
  };

  constructor(props) {
    super(props);
    const { permissions, preferencesService } = this.props.deps;
    const { isMCC, channel } = this.props;
    this.isOptimizationScoreOn = !isMCC && channel === CHANNEL_TYPES.RECOMMENDATION;
    this.isDismissedTabEnabled = this.isOptimizationScoreOn && _.result(permissions, 'IsDismissedTabEnabled');
    this.isAutoApplyRecommendationEnabled = !isMCC && _.result(permissions, 'IsAutoApplyRecommendationEnabled');
    this.recommendationsDetailsLazy = null;
    this.recommendationsHistoryLazy = null;
    this.recommendationsBulkAARLazy = null;
    this.filteredSummaryViewLazy = null;
    preferencesService.initialize();
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    // if props passes in a category, that overrides the previous state
    const prevCategory = prevState && prevState.currentCategory;
    const currentCategory = nextProps.categoryType || prevCategory;

    return {
      currentCategory,
    };
  }

  state = {
    isAsyncApplyModalOpen: false,
    isApplyConfirmModalOpen: false,
    countRecommendation: 0,
    autoApplyTeachingBubbleVisible: !window.location.href.includes('isAutoApplyTeachingBubbleDisabled=true'),
    optimizationScoreTeachingBubbleVisible: !window.location.href.includes('isOSTeachingBubbleDisabled=true'),
  };

  componentDidMount() {
    if (window.survey && window.survey.surveyManager) {
      window.survey.surveyManager.trigger();
    }
    if (this.props.viewType !== VIEW_TYPES.HISTORY
      && this.props.viewType !== VIEW_TYPES.AUTO_APPLY_SETTINGS
      && this.props.viewType !== VIEW_TYPES.AUTO_APPLY_BULK_UPLOAD
      && this.props.viewType !== VIEW_TYPES.DETAILS) {
      this.updateSitemap();
    }

    if (this.props.viewType === VIEW_TYPES.SUMMARY
      && this.props.scope.levelAt === 'Campaign'
      && !_.isEmpty(this.props.data)) {
      this.checkCampaignStatus();
    }
  }

  componentDidUpdate(prevProps) {
    const isFromDetail = (prevProps.viewType === VIEW_TYPES.DETAILS &&
      this.props.viewType === VIEW_TYPES.SUMMARY) && !this.props.hasLoadToken();
    if (prevProps.campaignType !== this.props.campaignType || isFromDetail) {
      this.props.reload();
    }
    if (prevProps.data !== this.props.data) {
      // Filter category for VNext but not for history, auto-apply-setting, auto-apply-bulk-upload page
      if (this.props.viewType !== VIEW_TYPES.HISTORY
        && this.props.viewType !== VIEW_TYPES.AUTO_APPLY_SETTINGS
        && this.props.viewType !== VIEW_TYPES.AUTO_APPLY_BULK_UPLOAD) {
        this.updateSitemap();
      }
    }
  }

  componentWillUnmount() {
    const { permissions, cacheManager } = this.props.deps;
    if (this.props.isMCC) {
      this.props.deps.appState.unset('account_id');
    }
    if (this.floatingBannerId) {
      notificationStore.dismiss(this.floatingBannerId);
    }

    // After apply/dismiss trigger, invalidate campaign cache when leaving recommendation page.
    if (permissions.IsRecommendationDataCacheEnabled
      && !_.isNull(cacheManager)
      && !_.isUndefined(getRecommendationCache('need-invalidate-campaign-cache'))
      && getRecommendationCache('need-invalidate-campaign-cache') === true) {
      setRecommendationCache('need-invalidate-campaign-cache', false);
      cacheManager.invalidate('Campaign');
    }

    // Apply/dismiss recommendation: invalidate recommendation summary data cache.
    if (permissions.IsRecommendationCacheDetailPageDataEnabled
      && !_.isUndefined(getRecommendationCache('recommendation-summary-raw-data'))) {
      setRecommendationCache('recommendation-summary-raw-data', undefined);
    }
  }

  getCategories = (availableCategories = [], data = {}, op = {}) => {
    let categories;
    if (this.props.isMCC || !this.isOptimizationScoreOn) {
      categories = _.unique(_.pluck(data, op.isAutoApplySettings ? 'Category' : 'category'));
    } else {
      categories = op.isAutoApplySettings ?
        _.unique(_.pluck(data, 'Category')) : availableCategories;
    }

    if (_.isEmpty(categories)) {
      return [];
    } else if (op.isAutoApplySettings) {
      return categories;
    }

    return _.filter(RECOMMENDATION_CATEGORIES, category =>
      category === RECOMMENDATION_CATEGORIES.ALL ||
      _.contains(categories, RECOMMENDATION_CATEGORIES_IDS[category]));
  };

  checkCampaignStatus = () => {
    this.props.deps.jsdata.Campaign.findAll({
      limit: 1,
      select: ['DeliveryStatus'],
      where: { Id: { $eq: this.props.scope.campaignId } },
    }, {}).then((response) => {
      if (response.length && response.length > 0 && response[0].DeliveryStatus === 'CampaignUserPaused') {
        const customizedMessage = (
          <div className={this.props.classes.customizedMessage}>
            <span>{this.props.vnextDeps.newI18n.getString(_TL_('Enable this paused campaign to start showing ads.'))}</span>
            <button
              onClick={() => {
                this.props.store.state.updateCampaignStatus({ id: 'active' });
                notificationStore.dismiss(this.floatingBannerId);
              }}
              style={{
                background: '#FFFFFF',
                border: '1px solid #C8C6C4',
                boxSizing: 'border-box',
                borderRadius: 2,
                width: 105,
                height: 24,
                position: 'relative',
                left: 81,
              }}
            >
              {this.props.vnextDeps.newI18n.getString(_TL_('Click to enable'))}
            </button>
          </div>
        );
        this.floatingBannerId = this.props.showAlertHandler({
          message: customizedMessage,
          level: 'Warning',
          dismissible: true,
        });
      }
    });
  };

  sitemapper = (siteMap) => {
    const { availableCategories, isMCC } = this.props;
    const recommendationSiteMap = findSiteMap(siteMap, ({ id }) => id === 'recommendations');
    if (recommendationSiteMap && _.size(recommendationSiteMap.children)) {
      recommendationSiteMap.children = _.filter(
        recommendationSiteMap.children,
        item => item.id === 'All'
          || (isMCC || !this.isOptimizationScoreOn ?
            (_.contains(this.getCategories([], this.props.data), item.id)
              || (this.isDismissedTabEnabled &&
                _.contains(this.getCategories([], this.props.dismissedData), item.id)))
            : _.contains(this.getCategories(availableCategories), item.id))
      );
    }
    return siteMap;
  };

  updateSitemap = () => {
    // renew sitemapper to update the categories
    // eslint-disable-next-line max-len
    this.props.vnextDeps.customMapperStore.setState({ customMapper: siteMap => this.sitemapper(siteMap) });
  };

  logOpportunityEvent = ({
    type = null,
    action,
    position = null,
    input = null,
    context = null,
  }) => {
    const guid = action === ADINSIGHT_LOG_ACTION_TYPE.FEEDBACK ?
      null :
      this.props.guid;

    this.props.currentActivity.trace({
      type: type || '',
      typeId: RECOMMENDATION_IDS[type],
      action,
      input,
      campaignId: this.props.scope.campaignId,
      channel: this.props.isMCC ? CHANNEL_TYPES.MCCRECOMMENDATION : CHANNEL_TYPES.RECOMMENDATION,
      position,
      guid,
      context: JSON.stringify(context),
    }, ADINSIGHT_LOG_API_NAME.RECOMMENDATION);
  };

  addCouponToRecommendations = (rawCouponData, rawRecommendationData) => {
    if (!_.isNull(rawCouponData) && rawCouponData.length) {
      const coupon = rawCouponData[0];
      const couponFeatureId = coupon.FeatureId.toString();
      if (_.isUndefined(FAC_RECOMMENDATION_CONFIG[couponFeatureId])) {
        return;
      }
      const priorities = FAC_RECOMMENDATION_CONFIG[couponFeatureId].priority;
      const types = _.keys(rawRecommendationData);

      const couponEligibleType = _.chain(types)
        .filter(type => _.contains(priorities, type))
        .sortBy(type => _.indexOf(priorities, type))
        .first()
        .value();

      if (couponEligibleType && _.isUndefined(rawRecommendationData[couponEligibleType].coupon)) {
        _.extend(rawRecommendationData[couponEligibleType], { coupon });
      }
    }
  };

  showAsyncApplyModal = (pollTask) => {
    this.pollTask = pollTask;
    this.setState({ isAsyncApplyModalOpen: true });
  };

  closeAsyncApplyModal = () => {
    this.pollTask.stop();
    this.setState({ isAsyncApplyModalOpen: false });
  };

  showApplyConfirmModal = ({
    onApply, countRecommendation, onReject = _.noop, type,
  }) => {
    _.defer(() => this.setState({ isApplyConfirmModalOpen: true, countRecommendation }));
    this.onApplyConfirm = onApply;
    this.onApplyReject = onReject;
    this.onApplyRecommendationType = type;
  };

  closeApplyConfirmModal = () => {
    this.setState({ isApplyConfirmModalOpen: false });
  };

  confirmApplyConfirmModal = () => {
    if (_.isFunction(this.onApplyConfirm)) {
      this.onApplyConfirm();
    }
    this.closeApplyConfirmModal();
  };

  rejectApplyConfirmModal = () => {
    if (_.isFunction(this.onApplyReject)) {
      this.onApplyReject();
    }
    this.closeApplyConfirmModal();
  };

  initLegacyDeps = () => {
    if (_.isUndefined(this.props.deps.adDisplayUrlService)) {
      this.props.deps.adDisplayUrlService = adDisplayUrlService;
    }
    if (_.isUndefined(this.props.deps.combineText)) {
      this.props.deps.combineText = combineText;
    }
  };

  renderDownloadButton = (context, isOptimizationScoreOn = false) => (
    <DownloadToolbarButton
      i18n={this.props.deps.i18n}
      disabled={_.isEmpty(this.props.data)}
      logOpportunityEvent={this.logOpportunityEvent}
      data={this.props.data}
      context={_.extend(context, { UIVersion: '2.0' })}
      title={this.props.deps.i18n.getString('Details_View_Download_All_Rec')}
      className="recommendation-download-button btn btn-secondary"
      downloadService={this.props.dataService}
      {..._.pick(this.props, 'channel', 'campaignType', 'filterService')}
      isOptimizationScoreOn={isOptimizationScoreOn}
    />
  );

  render() {
    let { currentCategory } = this.state;
    const currency = this.props.deps.pageContext.AccountCurrencyCode;
    const readOnly = isReadOnly && isReadOnly(this.props.deps.appConfig, this.props.isMCC);
    const {
      i18n,
      permissions,
    } = this.props.deps;
    const {
      overallOptimizationScoreBar,
      availableCategories,
      data,
      dismissedData,
      rawCouponData,
    } = this.props;

    let categories;
    if (this.props.isMCC || !this.isOptimizationScoreOn) {
      categories = this.isDismissedTabEnabled ?
        this.getCategories([], data).concat(this.getCategories([], dismissedData)) :
        this.getCategories([], data);
    } else {
      categories = this.getCategories(availableCategories);
    }
    this.categories = categories;

    // Resolve invalid category
    if (this.props.viewType === VIEW_TYPES.SUMMARY && !_.contains(categories, currentCategory)
      && currentCategory !== RECOMMENDATION_CATEGORIES.ALL
    ) {
      currentCategory = RECOMMENDATION_CATEGORIES.ALL;
      this.props.viewCategory(RECOMMENDATION_CATEGORIES.ALL)();
    }

    if (_.any(
      data,
      rec => _.has(FAC_RECOMENDATIONTYPE_FEATUREID_MAPPING, rec.type)
    )) {
      this.addCouponToRecommendations(rawCouponData, data);
    }

    const isDismissedCategory = currentCategory === RECOMMENDATION_CATEGORIES.DISMISSED;

    const context = {
      Source: null,
      Level: this.props.scope.levelAt,
      Category: this.props.channel !== 'competitionpage' ? currentCategory : null,
      CampaignIds: this.props.scope.campaignId ? [Number(this.props.scope.campaignId)] : [],
      AdGroupIds: this.props.scope.adGroupId ? [Number(this.props.scope.adGroupId)] : [],
    };

    // add Source if not from recommendation summary page
    if (this.props.viewType === VIEW_TYPES.DETAILS && this.props.source !== 'summarypage') {
      context.Source = this.props.source;
    }

    // set recommendation data for subpage menu
    if (this.isOptimizationScoreOn) {
      this.props.vnextDeps.recommendationDataStore.setState({
        overallOptimizationScoreBar,
        categoryScoreUpLifts: this.props.categoryScoreUpLifts,
        renderDownloadButton: _.partial(this.renderDownloadButton, context),
        isAutoApplyRecommendationEnabled: this.isAutoApplyRecommendationEnabled
          && !this.props.isMCC,
      });
    }

    let recommendationsDetails = null;
    if (this.props.viewType === VIEW_TYPES.DETAILS) {
      if (_.isNull(this.recommendationsDetailsLazy)) {
        this.recommendationsDetailsLazy = React.lazy(() => import(/* webpackMode: 'eager' */ './recommendations-details-view').then(({ RecommendationsDetails }) => ({ default: RecommendationsDetails })));
      }
      const RecommendationsDetailsLazy = this.recommendationsDetailsLazy;
      recommendationsDetails = (<RecommendationsDetailsLazy
        {...this.props}
        data={isDismissedCategory ? this.props.dismissedData : this.props.data}
        type={this.props.recommendationType}
        campaignType={this.props.campaignType}
        currency={currency}
        navigateBack={this.props.viewCategory(this.state.currentCategory)}
        prevCategoryType={this.state.currentCategory}
        readOnly={readOnly}
        context={_.extend(context, { UIVersion: '2.0' })}
        showAsyncApplyModal={this.showAsyncApplyModal}
        closeAsyncApplyModal={this.closeAsyncApplyModal}
        showApplyConfirmModal={this.showApplyConfirmModal}
        setData={this.props.setData}
        newI18n={this.props.vnextDeps.newI18n}
        downloadService={this.props.dataService}
        isOptimizationScoreOn={this.isOptimizationScoreOn}
        isAutoApplyRecommendationEnabled={this.isAutoApplyRecommendationEnabled}
        serverContext={this.props.serverContext}
        isDismissedCategory={isDismissedCategory}
      />);
    }

    let recommendationsHistory = null;
    if (this.props.viewType === VIEW_TYPES.HISTORY) {
      if (_.isNull(this.recommendationsHistoryLazy)) {
        this.recommendationsHistoryLazy = React.lazy(() => import(/* webpackMode: 'eager' */ './recommendations-history').then(({ RecommendationsHistory }) => ({ default: RecommendationsHistory })));
      }
      const RecommendationsHistoryLazy = this.recommendationsHistoryLazy;
      recommendationsHistory = (<RecommendationsHistoryLazy
        {...this.props}
        navigateBack={this.props.backToRecommendation()}
        newI18n={this.props.vnextDeps.newI18n}
        isAutoApplyRecommendationEnabled={this.isAutoApplyRecommendationEnabled}
      />);
    }

    let recommendationBulkAAR = null;
    if (this.props.viewType === VIEW_TYPES.AUTO_APPLY_BULK_UPLOAD) {
      if (_.isNull(this.recommendationsBulkAARLazy)) {
        this.recommendationsBulkAARLazy = React.lazy(() => import(/* webpackMode: 'eager' */ './recommendations-bulk-aar').then(({ RecommendationsBulkAAR }) => ({ default: RecommendationsBulkAAR })));
      }
      const RecommendationsBulkAARLazy = this.recommendationsBulkAARLazy;
      recommendationBulkAAR = (<RecommendationsBulkAARLazy
        {...this.props}
        navigateBack={this.props.backToRecommendation()}
        newI18n={this.props.vnextDeps.newI18n}
        isAutoApplyRecommendationEnabled={this.isAutoApplyRecommendationEnabled}
      />);
    }

    let filteredSummaryView = null;
    if (this.props.viewType === VIEW_TYPES.SUMMARY) {
      if (_.isNull(this.filteredSummaryViewLazy)) {
        this.filteredSummaryViewLazy = React.lazy(() => import(/* webpackMode: 'eager' */ '@bingads-webui-campaign-react/recommendation-summary-view').then(({ FilteredSummaryView }) => ({ default: FilteredSummaryView })));
      }
      this.initLegacyDeps();
      const FilteredSummaryViewLazy = this.filteredSummaryViewLazy;
      filteredSummaryView = (<FilteredSummaryViewLazy
        {...this.props}
        data={isDismissedCategory ? this.props.dismissedData : this.props.data}
        type={null}
        currency={currency}
        filterCategory={RECOMMENDATION_CATEGORIES_IDS[this.state.currentCategory]}
        readOnly={readOnly}
        context={_.extend(context, { UIVersion: '2.0' })}
        showAsyncApplyModal={this.showAsyncApplyModal}
        closeAsyncApplyModal={this.closeAsyncApplyModal}
        showApplyConfirmModal={this.showApplyConfirmModal}
        downloadService={this.props.dataService}
        isOptimizationScoreOn={this.isOptimizationScoreOn}
        newI18n={this.props.vnextDeps.newI18n}
        isDismissedTabEnabled={this.isDismissedTabEnabled}
        isFromSummary
        isAutoApplyRecommendationEnabled={this.isAutoApplyRecommendationEnabled}
      />);
    }

    let confirmFormTitle;
    let confirmFormContent;
    if (this.onApplyRecommendationType === RECOMMENDATION_TYPES.SSC_2_PMAX_MIGRATION) {
      confirmFormTitle = this.state.countRecommendation === 1 ?
        this.props.vnextDeps.newI18n.getString(_TL_('Are you sure you want to upgrade smart shopping campaign to Performance Max campaigns?')) :
        this.props.vnextDeps.newI18n.getString(_TL_('Are you sure you want to upgrade all smart shopping campaigns to Performance Max campaigns?'));
      confirmFormContent = this.props.vnextDeps.newI18n.getString(_TL_('Once you confirm, the upgrade process will continue until it completes and cannot be discontinued.'));
    } else {
      confirmFormTitle = this.state.countRecommendation === 1 ?
        i18n.getString('Summary_Card_Apply') :
        i18n.getString('Summary_Card_Apply_All');
      confirmFormContent = this.state.countRecommendation === 1 ?
        i18n.getString('Recommendation_Apply_All_Confirm_Singular') :
        i18n.getString('Recommendation_Apply_All_Confirm', { count: this.state.countRecommendation });
    }

    return (
      <div className="recommendations-tab-view">
        {this.props.viewType !== VIEW_TYPES.HISTORY
          && this.props.viewType !== VIEW_TYPES.AUTO_APPLY_SETTINGS
          && this.props.viewType !== VIEW_TYPES.AUTO_APPLY_BULK_UPLOAD &&
          <ul className="nav navbar-nav" >
            {(this.props.viewType === VIEW_TYPES.SUMMARY &&
              _.difference(_.keys(this.props.data), NOT_SUPPORT_DOWNLOAD_TYPES).length !== 0) &&
              !this.props.isMCC && this.props.channel === CHANNEL_TYPES.COMPETITION &&
              <li className="recommendation-download">
                {this.renderDownloadButton(context)}
              </li>
            }
            <li
              className={classNames(
                'recommendation-apply-history-nav',
                this.props.viewType === VIEW_TYPES.SUMMARY
                  ? 'recommendation-apply-history-nav-left'
                  : 'recommendation-apply-history-nav-right'
              )}
              key="apply-history"
            />
          </ul>
        }
        {this.props.viewType === VIEW_TYPES.DETAILS &&
          <div className="recommendations-details recommendation-details-view">
            <React.Suspense fallback={null}>
              {recommendationsDetails}
            </React.Suspense>
          </div>
        }
        {this.props.viewType === VIEW_TYPES.SUMMARY &&
          <div className="recommendations">
            <React.Suspense fallback={null}>
              {filteredSummaryView}
            </React.Suspense>
          </div>
        }
        {this.props.viewType === VIEW_TYPES.HISTORY &&
          <div className="recommendations-history">
            <React.Suspense fallback={null}>
              {recommendationsHistory}
            </React.Suspense>
          </div>
        }
        {this.props.viewType === VIEW_TYPES.AUTO_APPLY_BULK_UPLOAD &&
          <div className="recommendation-auto-apply-bulk-upload">
            <React.Suspense fallback={null}>
              {recommendationBulkAAR}
            </React.Suspense>
          </div>
        }
        {this.isAutoApplyRecommendationEnabled
          && this.props.viewType === VIEW_TYPES.AUTO_APPLY_SETTINGS &&
          <div className="recommendation-auto-apply-settings">
            <RecommendationsAutoApplySettings
              dataService={this.props.dataService}
              getCategories={this.getCategories}
              navigateBack={this.props.backToRecommendation()}
              newI18n={this.props.vnextDeps.newI18n}
              readOnly={readOnly}
              i18n={i18n}
              appConfig={this.props.deps.appConfig}
              classes={this.props.classes}
              viewHistory={this.props.viewHistory}
              reloadSummaryPage={this.props.reload}
              hideAutoApplyTeachingBubble={() =>
                this.setState({ autoApplyTeachingBubbleVisible: false })}
              scope={this.props.scope}
              permissions={permissions}
            />
          </div>
        }
        <RecommendationModal
          isOpen={this.state.isAsyncApplyModalOpen}
          onCancel={this.closeAsyncApplyModal}
        >
          <AsyncApplyForm
            i18n={this.props.deps.i18n}
            runInBackground={this.closeAsyncApplyModal}
            routeApplyHistory={() => {
              this.closeAsyncApplyModal();
              this.props.viewHistory();
            }}
          />
        </RecommendationModal>
        <RecommendationModal
          isOpen={this.state.isApplyConfirmModalOpen}
          onCancel={this.rejectApplyConfirmModal}
        >
          <ConfirmForm
            title={confirmFormTitle}
            content={confirmFormContent}
            confirmString={i18n.getString('Recommendation_Confirm')}
            cancelString={i18n.getString('Cancel')}
            onConfirm={this.confirmApplyConfirmModal}
            onCancel={this.rejectApplyConfirmModal}
            i18n={i18n}
          />
        </RecommendationModal>
        {
          this.isOptimizationScoreOn && this.state.optimizationScoreTeachingBubbleVisible && this.props.viewType === VIEW_TYPES.SUMMARY &&
          <OptimizationScoreTeachingBubbleWithUserGovernance
            currentActivity={this.props.currentActivity}
            i18n={this.props.vnextDeps.newI18n}
            preferencesService={this.props.deps.preferencesService}
            overallOptimizationScoreBar={this.props.overallOptimizationScoreBar}
            categoryScoreUpLifts={this.props.categoryScoreUpLifts}
            type={this.props.recommendationType}
            filterCategory={RECOMMENDATION_CATEGORIES_IDS[this.state.currentCategory]}
            data={isDismissedCategory ? this.props.dismissedData : this.props.data}
            featureName="optimization-score-teaching-bubble"
            onDone={() => { this.setState({ optimizationScoreTeachingBubbleVisible: false }); }}
            onDismiss={() => { this.setState({ optimizationScoreTeachingBubbleVisible: false }); }}
            onClose={() => { this.setState({ optimizationScoreTeachingBubbleVisible: false }); }}
            userGovernanceConfig={getTeachingBubbleUserGovernanceConfig()}
          />
        }
        {this.isAutoApplyRecommendationEnabled &&
          this.state.autoApplyTeachingBubbleVisible && this.props.viewType === VIEW_TYPES.SUMMARY &&
          <TeachingBubble
            featureName="auto-apply-teaching-bubble"
            title={this.props.vnextDeps.newI18n.getString(_TL_('Auto-apply recommendation settings'))}
            content={this.props.vnextDeps.newI18n.getString(_TL_('Save time and get better performance with auto-apply recommendations. Manage your settings here.'))}
            onDone={() => { this.setState({ autoApplyTeachingBubbleVisible: false }); }}
            onDismiss={() => { this.setState({ autoApplyTeachingBubbleVisible: false }); }}
            onClose={() => { this.setState({ autoApplyTeachingBubbleVisible: false }); }}
            primaryButtonText={this.props.vnextDeps.newI18n.getString(_TL_('Got it'))}
            targetElement={document.querySelector('.recommendation-auto-apply-item')}
            className="recommendation-auto-apply-teaching-bubble"
          />
        }
      </div>
    );
  }
}

export const RecommendationTab =
  withStateStore(recommendationTab, sharedComponentFunctionStateStore);
